'use strict';

import Vue from 'vue';
import VueRouter from 'vue-router';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/rti.css';
import VeeValidate from 'vee-validate';
import GenerateToken from '../vue/generateToken.vue';
import Login from '../vue/login.vue';
import Rti from '../vue/rti.vue';
import PageNotFound from '../vue/pageNotFound.vue';

Vue.use(VueRouter);
Vue.use(VeeValidate);

const routes = [
  {
    name: 'generateToken',
    path: '/generate-token',
    component: GenerateToken
  },
  {
    name: 'login',
    path: '/',
    component: Login
  },
  {
    name: 'rti',
    path: '/rti',
    component: Rti,
    props: true
  },
  {
    name: 'pageNotFound',
    path: '*',
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

const app = new Vue({
  router
}).$mount('#app');
